import { render, staticRenderFns } from "./Ot-Listing-Tem.vue?vue&type=template&id=2fad60c1"
import script from "./Ot-Listing-Tem.vue?vue&type=script&lang=js"
export * from "./Ot-Listing-Tem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports